import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

const stripePromise = loadStripe('pk_test_51T295qRpgJ2vc1fiIxv7pNNNTuahZhoGp7lbp3a3vDKqG8wYVC6jctkqzpjBcYR3lW8IGhJ3thuBzom94gcMWMyq004sBFjvGN');

const CheckoutForm = ({ amount, name, email, onSuccess, onCancel }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [processing, setProcessing] = useState(false);
    const [cardError, setCardError] = useState('');

    const handleSubmit = async(e) => {
        e.preventDefault();
        setProcessing(true);
        setCardError('');

        if (!stripe || !elements) {
            setProcessing(false);
            return;
        }

        const cardElement = elements.getElement(CardElement);

        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement,
            billing_details: {
                name: name,
                email: email,
            },
        });

        if (error) {
            setCardError(error.message);
            setProcessing(false);
        } else {
            // Call onSuccess with the payment method
            onSuccess(paymentMethod);
            setProcessing(false);
        }
    };

    return ( <
        form onSubmit = { handleSubmit }
        className = "stripe-form" >
        <
        div className = "stripe-card-container" >
        <
        label className = "stripe-label" > Card Details < /label> <
        div className = "stripe-card-element" >
        <
        CardElement options = {
            {
                style: {
                    base: {
                        fontSize: '16px',
                        color: '#424770',
                        '::placeholder': { color: '#aab7c4' },
                        iconColor: '#2e7d32',
                    },
                    invalid: {
                        color: '#9e2146',
                        iconColor: '#9e2146',
                    },
                },
            }
        }
        /> <
        /div> {
            cardError && < div className = "stripe-error" > { cardError } < /div>} <
                div className = "test-card-info" >
                <
                p > 🔹 < strong > Test Card: < /strong> 4242 4242 4242 4242</p >
                <
                p > 📅 < strong > Expiry: < /strong> Any future date (12/
            25) < /p> <
        p > 🔒 < strong > CVC: < /strong> Any 3 digits (123)</p >
        <
        /div> <
        /div>

        <
        div className = "stripe-buttons" >
        <
        button type = "button"
        onClick = { onCancel }
        className = "stripe-cancel-btn" > Cancel < /button> <
        button type = "submit"
        disabled = {!stripe || processing }
        className = "stripe-pay-btn" > { processing ? 'Processing...' : `Pay ₹${amount}` } <
        /button> <
        /div> <
        /form>
    );
};

const StripeCheckout = (props) => {
    return ( <
        Elements stripe = { stripePromise } >
        <
        CheckoutForm {...props }
        /> <
        /Elements>
    );
};

export default StripeCheckout;